
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBar } from '@angular/material/snack-bar';
//import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
// import { url } from 'inspector';
@Injectable()
export class GeneralService {
  constructor(private http: HttpClient) { }
  // api="http://backend-avt.pmc.tn/api/";
  //api="http://unilog.ddns.net:86/api/";
  
  api = "http://srv-msgi.pmc.tn/api/"
  url = "recherche/tbdata?tablere=";
  urlQRCode = "http://srv-msgi.pmc.tn/api/pointageuniges/QRCode?code="
  userConnecter: string
  userToken: string
  chargement = true;

  affaireCode: string
  changeAffaireCode = new Subject<String>();

  updateAffaireCode(affaireCode) {
    console.log(affaireCode)
    this.affaireCode = affaireCode
    this.changeAffaireCode.next(this.affaireCode)
  }


  // horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  // userConnecter :string = "8"
  clone(obj) {
    var copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.clone(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
      }
      return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
  }

  cloneObjectProperties(receverObject, senderObject) {
    for (let key in receverObject) {
      if (key in senderObject) {
        receverObject[key] = senderObject[key]
      }
    }

  }

  clearForm(formObject) {
    for (let key in formObject) {
      formObject[key] = null
    }
  }
  isEgaleObject(obj1: Object, obj2: Object) {
    var str1 = JSON.stringify(obj1);
    var str2 = JSON.stringify(obj2);
    return str1 == str2;
  }
  httpGet(url: string) {
    return this.http.get<any>(this.api + url);
  }

  login(login: string, password: string) {
    return this.http.get<any>("http://unilog.ddns.net:83/api/Users/login?id=" + login + "&pw=" + password)
  }
  rechercheTable(tablere: string) {
    return this.http.get<any>(this.api + "recherche/tbdata?tablere=" + tablere);
  }

  rechercheTablewithparam(tablere: string, param: string) {
    return this.http.get<any>(this.api + "recherche/tbdata?tablere=" + tablere + "&param=" + param);
  }

  getDS(code: string) {
    return this.http.get<any>(this.api + "ds/formdata?code=" + code);
  }

  getDSWithParam(code: string, param: string) {
    return this.http.get<any>(this.api + "ds/formdata?code=" + code + "&val=" + param);
  }
  enregisterTable(ds) {
    return this.http.post<any>(this.api + 'ds/post', ds);
  }
  delete(data, codeform) {
    return this.http.delete(this.api + 'ds/delete?control=-1&data=' + data + '&codeform=' + codeform);
  }
  distinct(ds, attribut) {
    return ds.map(item => eval("item." + attribut)).filter((value, index, self) => self.indexOf(value) === index);
  }

  showDialog(msg: string, status: boolean) {
    //     //   let config = new MatSnackBarConfig();
    //     //   config.horizontalPosition = this.horizontalPosition;
    //     //   config.duration = true ? 6000 : 0;
    // console.log(status)
    //     if(!status)
    //   { this.toastr.error(msg, 'Erreur', { timeOut: 2000,positionClass:"toast-bottom-center"});}
    //    else
    //    {this.toastr.success(msg, 'Succès',{
    //       timeOut: 3000,positionClass:"toast-bottom-center"
    //     });}
    // //  this.snackBar.open(msg, true ? "" : undefined, config);
  }


  redimentionnerImage(image, width, height, netteter) {
    var maxWidth = width,
      maxHeight = height,
      imageWidth = image.width,
      imageHeight = image.height;
    if (imageWidth > imageHeight) {
      imageHeight *= maxWidth / imageWidth;
      imageWidth = maxWidth;
    }
    else {
      imageWidth *= maxHeight / imageHeight;
      imageHeight = maxHeight;
    }
    var mime_type = "image/jpeg";
    var canvas = document.createElement('canvas');
    canvas.width = imageWidth;
    canvas.height = imageHeight;
    image.width = imageWidth;
    image.height = imageHeight;
    var ctx1 = canvas.getContext("2d");
    ctx1.drawImage(image, 0, 0, imageWidth, imageHeight);
    var newImageData = canvas.toDataURL(mime_type, netteter / 100);
    var result_image_obj = new Image();
    result_image_obj.src = newImageData;
    if (image.src.length < canvas.toDataURL(mime_type, 1).length)
      return image.src;
    else
      return canvas.toDataURL(mime_type, 1);
  }

  async addFiles(initDoc, File_Content, File_Text, File_Key, File_Type, File_Parent, clickMode, File_Groupe, File_Lien) {
    var id;
    var doc = this.clone(initDoc);
    if (clickMode != "renommer") {
      doc.files[0].File_Parent = File_Parent;
      doc.files[0].File_Content = File_Content;
      doc.files[0].File_Text = File_Text;
      doc.files[0].File_Key = File_Key;
      doc.files[0].File_Type = File_Type;
      doc.files[0].File_Groupe = File_Groupe;
      doc.files[0].File_Lien = File_Lien;
      if (clickMode == "crerFichier") {
        doc.files[0].File_Dll = "jstree-file";
      }
      if (clickMode == "crerDossier") {
        doc.files[0].File_Dll = "jstree-folder";
      }
      id = await this.enregisterTable(doc).toPromise();
      // this.showDialog("Document enregisté",true);
    }
    return id;
  }
}

